<template>
    <page>
        <div class="shadow-25 col-4">
            <v-header :title="'4004 - ' + $T('wrong market')" icon="error"/>
            <card title-inverted
                  title-color="primary"
                  footer-color="white"
                  width="100%">

                <div class="q-pa-xl text-center">
                    {{ $T('the user does not belong to this market.') }}
                </div>
            </card>
        </div>
    </page>
</template>

<script>
    export default {
        layout: 'basic',
        name: 'NoLendingPoint',
        methods: {
            async autoLogoff () {
                await this.$store.dispatch('auth/logout')
            }
        },
        created () {
            this.autoLogoff()
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/errors/4004.vue